import { Col, Row } from "antd";
import React from "react";
import BaseButton from "../../components/common/Button/BaseButton";
import InputSearchBox from "../../components/common/Input/InputSearchBox";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmStoreStatus,
  deleteProduct,
  resetStatus,
  setOpenModalGetLogStore,
} from "../../services/slice/StoreSlice";
import { storeProductSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import TranslateText from "../../components/common/TranslateText";
import NoSearchResults from "../../components/common/NoSearchResults";
import { useState } from "react";

import TableProductStatistics from "../../components/common/Table/TableProductStatistics";
import { exportReportProduct } from "../../services/slice/statisticsSlice";
import HeaderSort from "../../components/common/HeaderSort";
const ProductStatistics = () => {
  const stateStore = useSelector(storeProductSelector);
  const [valueSearch, setValueSearch] = useState("");
  const [config, setConfig] = useState({
    search: "",
    properties: "views",
    option: {
      limit: 10,
      offset: 1,
      order: "asc",
    },
  });

  return (
    <div className="wrapperStoreManager">
      <Notify
        isNotify={stateStore.isNotify}
        reset={resetStatus}
        title={"Bkav Pro"}
        content={stateStore.msg}
        type={stateStore.typeNotify}
      />
      <HeaderSort
        config={config}
        handleExport={exportReportProduct}
        setValueSearch={setValueSearch}
        setConfig={setConfig}
        title={"Thống kê tương tác của Khách hàng với sản phẩm"}
      />
      <Row>
        {stateStore.config.search && !stateStore.data.length ? (
          <NoSearchResults />
        ) : (
          <TableProductStatistics
            setConfig={setConfig}
            config={config}
            valueSearch={valueSearch}
          />
        )}
      </Row>
    </div>
  );
};

export default ProductStatistics;
